import { Clock, Globe, Webhook } from 'lucide-react';
import type { CustomNodeProps } from '../../types/nodes';
import { BaseNode } from './BaseNode';
import { StartHttpEndpointConfig } from './StartHttpEndpointConfig';
import { StartScheduleConfig } from './StartScheduleConfig';
import { StartWebhookConfig } from './StartWebhookConfig';

export function StartWebhookNode(props: CustomNodeProps) {
	return (
		<BaseNode
			{...props}
			icon={Webhook}
			title="Webhook Trigger"
			description="Triggers when a webhook is received"
			configComponent={StartWebhookConfig}
			canHaveInputs={false}
			colorScheme={{
				light: {
					bg: 'bg-emerald-50',
					border: 'border-emerald-200',
					text: 'text-emerald-700',
					icon: 'text-emerald-600',
				},
				dark: {
					bg: 'dark:bg-emerald-900/20',
					border: 'dark:border-emerald-800',
					text: 'dark:text-emerald-300',
					icon: 'dark:text-emerald-400',
				},
			}}
		/>
	);
}

export function StartScheduleNode(props: CustomNodeProps) {
	return (
		<BaseNode
			{...props}
			icon={Clock}
			title="Schedule Trigger"
			description="Triggers on a schedule"
			configComponent={StartScheduleConfig}
			canHaveInputs={false}
			colorScheme={{
				light: {
					bg: 'bg-emerald-50',
					border: 'border-emerald-200',
					text: 'text-emerald-700',
					icon: 'text-emerald-600',
				},
				dark: {
					bg: 'dark:bg-emerald-900/20',
					border: 'dark:border-emerald-800',
					text: 'dark:text-emerald-300',
					icon: 'dark:text-emerald-400',
				},
			}}
		/>
	);
}

export function StartHttpEndpointNode(props: CustomNodeProps) {
	return (
		<BaseNode
			{...props}
			icon={Globe}
			title="HTTP Endpoint"
			description="Triggers via HTTP API with HMAC authentication"
			configComponent={StartHttpEndpointConfig}
			canHaveInputs={false}
			colorScheme={{
				light: {
					bg: 'bg-emerald-50',
					border: 'border-emerald-200',
					text: 'text-emerald-700',
					icon: 'text-emerald-600',
				},
				dark: {
					bg: 'dark:bg-emerald-900/20',
					border: 'dark:border-emerald-800',
					text: 'dark:text-emerald-300',
					icon: 'dark:text-emerald-400',
				},
			}}
		/>
	);
}
